// Select the node that will be observed for mutations
const productList = document.querySelector(".boost-sd__filter-product-list.boost-sd__filter-product-list--ready");

if (!productList) {
  console.error("Product list not found!");
} else {
  const config = { childList: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.target === productList) {
        console.log("PRODUCT LIST RERENDERS");
        // Custom the product list here
        const itemList = document.querySelectorAll(".boost-sd__product-list .boost-sd__product-item");
        ajaxContent(itemList);
        if (window.screen.width > 768) {
          setTimeout(() => {      
              $('button.boost-sd__filter-tree-toggle-button.boost-sd__filter-tree-toggle-button--expand').trigger('click');
          }, 100)
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  try {
    observer.observe(productList, config);
  } catch (error) {
    console.error("Observer failed");
  }
}
//boost-sd__pagination-button boost-sd__pagination-button--rectangle boost-sd__pagination-button--load-previous
document.addEventListener("click", function (e) {
  //console.log('here outsideclick')
  if (e.target.classList.contains("boost-sd__pagination-button")) {
      //console.log('here inininininsideclick')

    let itemLength = document.querySelectorAll(".boost-sd__product-list .boost-sd__product-item").length;
    let isLoad = false;
    const interval = setInterval(doStuff, 100); // 2000 ms = start after 2sec
    function doStuff() {
      let itemList = document.querySelectorAll(".boost-sd__product-list .boost-sd__product-item");
      if (itemList.length > itemLength) {
        isLoad = true;
      }
      if (isLoad) {
        ajaxContent(itemList);
        clearInterval(interval);
      }
    }
    setTimeout(function () {
      clearInterval(interval);
    }, 2000);
  }
});

function ajaxContent(itemList) {
  let count = 0
  Array.from(itemList).map((itemElm) => {
    count = count + 1;
    const data = JSON.parse(itemElm.getAttribute("data-product"));
    let productHandleAjax = Shopify.routes.root + "products/" + data.handle + "?view=boost-turbo-custom-integration";
    let requestReg = formRequest(productHandleAjax);
    requestReg
      .then((res_success) => {
        let parse_res_success = JSON.parse(res_success);

        // Render Ajax Data
        let ajaxProductItems = document.querySelectorAll(
          '.boost-sd__alternative-product-container[data-product-id="' + parse_res_success.id + '"]',
        );
        Array.from(ajaxProductItems).forEach((ajaxProductItem) => {
          ajaxProductItem.innerHTML = parse_res_success.metafields;
          var a = (parse_res_success.metafields).trim();
          
          if (a == '') {
            
            $('.boost-sd__product-item[data-product-id="' + parse_res_success.id + '"]').find('.onhoverinfo_boost_ele').addClass('no-meta-ref');
            $('.boost-sd__product-item[data-product-id="' + parse_res_success.id + '"]').addClass('no-metafield-reference');
          }
        });
      })
      .catch((res_error) => {
        console.error(res_error);
      });
  });
}

function formRequest(value) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", value);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}
